import React from 'react';
import { Switch, Route } from 'react-router-dom';
import RootLayout from 'common/layout/root-layout';

import { Button } from 'semantic';
import AnalyticsToken from 'components/AnalyticsToken';
import { TectonicProvider, TimeRangePicker } from 'react-tectonic';

import Accounts from './Accounts';
import Msp from './Msp';
import Cpo from './Cpo';

import { sessionsExclusionFilter } from 'utils/visualizations';

import { TECTONIC_URL } from 'utils/env';
import { timeOptions } from '../timeOptions';
import { ITimeRange } from 'react-tectonic/types/types';

import { useTranslation } from 'react-i18next';
import { useUser } from 'contexts/user';

export default function ProviderAnalytics({ location }) {
  const { t } = useTranslation();

  const { provider } = useUser();

  let dateField = 'createdAt';
  const tokenPath = location.pathname.match(/cpo/)
    ? '/1/users/me/analytics-tokens/provider-cpo-analytics'
    : '/1/users/me/analytics-tokens/provider-msp-analytics';

  if (location.pathname.match(/cpo/)) {
    dateField = 'endedAt';
  }

  const [timeRange, setTimeRange] = React.useState<ITimeRange>({
    from: 'now-90d/d',
    to: 'now/d',
    label: t('analytics.last90Days', 'Last 90 Days'),
  });

  return (
    <RootLayout>
      <AnalyticsToken path={tokenPath}>
        <TectonicProvider
          baseUrl={TECTONIC_URL}
          collection="sessions"
          primaryColor={
            provider?.primaryColorHex
              ? `#${provider?.primaryColorHex}`
              : '#ff3d00'
          }
          dateField={dateField}
          statsFilter={sessionsExclusionFilter}
          timeRange={timeRange}>
          <React.Fragment>
            <div style={{ float: 'right', marginTop: '-10px' }}>
              <TimeRangePicker
                align="right"
                timeOptions={[
                  timeOptions.today,
                  timeOptions.yesterday,
                  timeOptions.ThisWeek,
                  timeOptions.ThisMonth,
                  timeOptions.ThisYear,
                  timeOptions.hoursInput,
                  timeOptions.daysInput,
                  //timeOptions.monthsInput,
                  //timeOptions.selectYear,
                  timeOptions.selectMonths,
                ]}
                onChange={setTimeRange}
                renderButton={(label, handleOnClick) => (
                  <Button
                    primary
                    icon="clock"
                    content={label}
                    onClick={handleOnClick}
                  />
                )}
              />
            </div>
            <Switch>
              <Route
                path="/analytics/msp"
                render={(props) => <Msp {...props} />}
              />
              <Route
                path="/analytics/cpo"
                render={(props) => <Cpo {...props} />}
              />
              <Route
                exact
                path="/analytics"
                render={(props) => <Accounts {...props} />}
              />
            </Switch>
          </React.Fragment>
        </TectonicProvider>
      </AnalyticsToken>
    </RootLayout>
  );
}
